import { render, staticRenderFns } from "./CompanyDetails.vue?vue&type=template&id=724efa29&scoped=true&"
import script from "./CompanyDetails.vue?vue&type=script&lang=ts&"
export * from "./CompanyDetails.vue?vue&type=script&lang=ts&"
import style0 from "./CompanyDetails.vue?vue&type=style&index=0&id=724efa29&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "724efa29",
  null
  
)

export default component.exports